<template>
  <div v-if="user">
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Por favor espere
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="networkLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Por favor espere {{networkLoading}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row no-gutters style="padding: 20px;">
      <v-col
        v-if="focus.length > 0"
        cols="12"
        sm="12"
        style="padding-bottom: 50px;"
      >
        <v-card
          color="orange"
          style="padding-bottom: 10px;"
        >
          <div style="padding: 10px 0 0 10px;">
          <small>Destacados:</small>
          </div>
        <list 
          :devices="focus"
          :onFocus="handleFocus"
          :onSelectNetwork="(v) => { selectedNetwork = v}"
          :onSyncDevice="handleForceSyncDevice"
          :onSelectedErrorDeviceID="handleSelectErrorDeviceID"
          :onSelectedNetworkConfig="(v) => { selectedNetworkConfig = v}"
          :onSelectedNotesDevice="(v) => { selectedNotesDevice = v}"
          :onSelectedIncrementalDevice="(v) => { selectedIncrementalDevice = v}"
          :onSelectedDetailsDevice="(v) => { selectedDetailsDevice = v}"
          :onSelectedScreenshotDevice="(v) => { selectedScreenshotDevice = v}"
          :readonly="readonly"
        />
        </v-card>
      </v-col>
      <v-col
        v-if="!readonly" 
        cols="12"
        sm="2"
      >
        <v-autocomplete
          v-model="selectedNetwork"
          :items="prepareNetworks(networks)"
          outlined
          dense
          label="Network"
          hide-details
          itemText="name"
          itemValue="id"
          :disabled="loading"
        />
      </v-col>
      <v-col
        v-if="!readonly" 
        cols="12"
        sm="2"
        style="padding-left: 5px;"
      >
        <v-autocomplete
          v-model="selectedQueryFilter"
          :items="queryFilters"
          outlined
          dense
          label="Filtro tabla"
          hide-details
          itemText="name"
          itemValue="id"
          :disabled="loading"
        />
      </v-col>
      <v-col
        v-if="!readonly" 
        cols="12"
        sm="3"
        style="padding-left: 10px;"
      >
        <search
          :onSearch="handleSearch"
          :showClear="true"
          :maxWidth="1000"
        />
      </v-col>
      <v-col
        v-if="!readonly" 
        cols="12"
        sm="2"
        style="padding-left: 5px;"
      >
        <div class="text-center">
          <v-menu
            v-model="showMenuHeadersCols"
            :close-on-content-click="false"
            :nudge-width="200"
            offset-x
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="indigo"
                dark
                v-bind="attrs"
                v-on="on"
                block
              >
                Columnas
              </v-btn>
            </template>

            <v-card>
              <v-list>
                <v-list-item 
                  v-for="col of headerCols"
                  :key="col.id"
                >
                  <v-list-item-action>
                    <v-switch
                      v-model="selectedHeaderCols"
                      multiple
                      :value="col.id"
                      color="purple"
                    />
                  </v-list-item-action>
                  <v-list-item-title>{{ col.name }}</v-list-item-title>
                </v-list-item>
              </v-list>

              <v-card-actions>
                <v-spacer/>
                <v-btn
                  color="primary"
                  text
                  @click="showMenuHeadersCols = false"
                >
                  Cerrar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </div>
      </v-col>
      <v-col
        v-if="!readonly" 
        cols="12"
        sm="2"
        style="padding-left: 5px;"
      >
        <div class="text-center">
          <v-menu
            v-model="showMenuOrderBy"
            :close-on-content-click="false"
            :nudge-width="200"
            offset-x
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="indigo"
                dark
                v-bind="attrs"
                v-on="on"
                block
              >
                Ordenar por
              </v-btn>
            </template>

            <v-card>
              <v-list>
                <v-list-item>
                    <v-select
                      v-model="selectedSortField"
                      :items="sortItems"
                      outlined
                      dense
                      label="Campo"
                    />
                </v-list-item>
                <v-list-item>
                    <v-select
                      v-model="selectedSortDirection"
                      :items="[ 'ASC', 'DESC' ]"
                      outlined
                      dense
                      label=""
                      hideDetails
                    />
                </v-list-item>
              </v-list>

              <v-card-actions>
                <v-spacer/>
                <v-btn
                  color="primary"
                  text
                  @click="showMenuOrderBy = false"
                >
                  Cerrar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </div>
      </v-col>
      <v-col
        v-if="!readonly" 
        cols="12"
        sm="1"
        style="padding-left: 10px;padding-top: 2px;"
      >
        <v-btn
          @click="handleRefresh"
          color="blue"
          block
          :disabled="loading"
          elevation="0"
          dark
        >
          refresh
        </v-btn>
      </v-col>
    </v-row>
    <list 
      :devices="devices"
      :onFocus="handleFocus"
      :onSelectNetwork="(v) => { selectedNetwork = v}"
      :onSelectedErrorDeviceID="handleSelectErrorDeviceID"
      :onSelectedNetworkConfig="(v) => { selectedNetworkConfig = v}"
      :onSelectedNotesDevice="(v) => { selectedNotesDevice = v}"
      :onSelectedIncrementalDevice="(v) => { selectedIncrementalDevice = v}"
      :onSelectedDetailsDevice="(v) => { selectedDetailsDevice = v}"
      :onSelectedScreenshotDevice="(v) => { selectedScreenshotDevice = v}"
      :readonly="readonly"
      :selectedHeaderCols="selectedHeaderCols"
    />
    <v-row no-gutters style="padding: 20px;">
      <v-col
        cols="12"
        sm="2"
      >
        <v-select
          v-model="itemsPerPage"
          :items="allItemsPerPage"
          outlined
          dense
          label="Items por pág."
          itemText="name"
          itemValue="id"
        />
      </v-col>
      <v-col
        cols="12"
        sm="1"
        style="padding-left: 10px;"
      >
        <h2>{{count}}</h2>
      </v-col>
      <v-col
        cols="12"
        sm="9"
      >
        <v-pagination
          v-model="page"
          :length="pageCount"
          @input="handleGetData"
          color="orange"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
      >
        <h1>Totales: </h1>
      </v-col>
      <v-col
        cols="12"
        sm="3"
        v-for="(item, index) of totals"
        :key="`card${index}`"
        style="padding: 5px;"
        @click="handleSelectCard(item)"
      >
        <v-card
          :color="item.color ? item.color : 'black'"
          dark
          style="padding: 10px;"
        >
          <h2>{{item.name}}</h2>
          <h1 style="font-size: 3rem; width: 100%;text-align: right;">{{item.count}}</h1>
        </v-card>
      </v-col>
    </v-row>
    <dialog-errors
      v-if="!readonly" 
      :apiURL="apiURL"
      :network="selectedErrorNetwork"
      :deviceID="selectedErrorDeviceID"
      :onClose="() => { selectedErrorDeviceID = null; selectedErrorNetwork = null }"
    />
    <dialog-network
      v-if="!readonly" 
      :device="selectedNetworkConfig"
      :onClose="() => { selectedNetworkConfig = null }"
    />
    <dialog-notes
      v-if="!readonly" 
      :apiURL="apiURL"
      :device="selectedNotesDevice"
      :onClose="handleCloseNotes"
    />
    <dialog-incremental
      v-if="!readonly" 
      :apiURL="apiURL"
      :device="selectedIncrementalDevice"
      :onClose="handleCloseIncremental"
    />
    <dialog-details
      v-if="!readonly" 
      :device="selectedDetailsDevice"
      :onClose="() => { selectedDetailsDevice = null }"
      :onUpdatePlayer="handleUpdatePlayer"
      :onSyncDevice="handleForceSyncDevice"
    />
    <dialog-screenshot
      v-if="!readonly" 
      :device="selectedScreenshotDevice"
      :onClose="() => { selectedScreenshotDevice = null }"
    />
  </div>
</template>

<script>
  import axios from 'axios'
  import utils from '@/services/utils'
  import Search from '@/components/Search'
  import List from './List'
  import DialogErrors from './DialogErrors'
  import DialogNetwork from './DialogNetwork'
  import DialogNotes from './DialogNotes'
  import DialogIncremental from './DialogIncremental'
  import DialogDetails from './DialogDetails'
  import DialogScreenshot from './DialogScreenshot'
  export default {
    name: 'Brightsignnetwork',
    components: {
      Search,
      List,
      DialogErrors,
      DialogNetwork,
      DialogNotes,
      DialogIncremental,
      DialogDetails,
      DialogScreenshot,
    },
    data () {
      return {
        loading: false,
        showMenuHeadersCols: false,
        showMenuOrderBy: false,
        networkLoading: null,
        user: null,
        selectedHeaderCols: [ 'focus', 'Network', 'Serial', 'Name', 'Model', 'Firmware', 'icons', 'LastHeartbeatTime', 'Uptime', 'Status' ],
        selectedNetwork: null,//'DESCUBREGROUP',//null,//'DGPLUS',
        selectedNetworkConfig: null,
        selectedErrorNetwork: null,
        selectedErrorDeviceID: null,
        selectedNotesDevice: null,
        selectedIncrementalDevice: null,
        selectedDetailsDevice: null,
        selectedScreenshotDevice: null,
        focus: [],
        networks: [],
        devices: [],
        selectedQueryFilter: 'onlyError',
        count: null,
        itemsPerPage: 20,
        page: 1,
        selectedSortField: null,
        selectedSortDirection: 'ASC',

        totals: [],
      }
    },
    computed: {
      paramToken () {
        return this.$route.params.token
      },
      token () {
        return localStorage.getItem('jwt')
      },
      readonly () {
        return this.paramToken ? true : false
      },
      allItemsPerPage () {
        return [
          { id: 20, name: 20 },
          { id: 50, name: 50 },
        ]
      },
      apiURL () {
        //return 'http://localhost:3600'
        return `${process.env.VUE_APP_ENV === 'production' ? 'https' : 'http'}://${process.env.VUE_APP_API_URL}`
      },
      headerCols () {
        const aux = [
          "Network",
          //"ID",
          "Serial",
          "Name",
          "Description",
          "Model",
          "Family",
          "Status",
          "Firmware",
          "LMD",
          "LastModifiedDate",
          "LastHeartbeatTime",
          "LastContentCheckTime",
          "LastErrorTime",
          "TimeStartDownload",
          "TimeEndDownload",
          //"PresentationID",
          "PresentationName",
          //"TargetGroupID",
          "TargetGroupName",
          "TargetTimeZone",
          //"ReportedGroupID",
          "ReportedGroupName",
          "ReportedTimeZone",
          "WiredDHCP",
          "WiredIP",
          "WiredSubnetMask",
          "WiredGateway",
          "WiredDNS1",
          "WiredDNS2",
          "WiredDNS3",
          "WirelessEnabled",
          "WirelessSSID",
          "WirelessDHCP",
          "WirelessIP",
          "WirelessSubnetMask",
          "WirelessGateway",
          "WirelessDNS1",
          "WirelessDNS2",
          "WirelessDNS3",
          "Uptime",
          "HealthReportingPeriod",
          "HealthStatus",
          /*
          "Snapshot",
          "WithNotes",
          "Installation",
          "Closed",
          "Recovery",
          "Viewing",
          "Missing",
          */
          "Incremental",
          "Offline",
          "OfflineTime",
          //"OfflineTimeUnit",
          //"UptimeError",
          //"IsError",
          //"icons",
          //"focus"
        ]
        return aux.map(item => {
          return {
            id: item,
            name: item.replace(/^./, char => char.toUpperCase())
          }
        })
      },
      queryFilters () {
        return [
          { id: 'onlyError', name: 'INCIDENCIAS', color: 'red' },
          { id: 'onlyErrorUptime', name: 'Uptime error', color: 'pink' },
          { id: null, name: 'TODOS' },
          { id: 'onlySnapshots', name: 'SNAPSHOTS', color: 'green' },
          { id: 'Installation', name: '[OCULTO] Pendiente de instalación' },
          { id: 'Closed', name: '[OCULTO] Temporalmente cerrado' },
          { id: 'Recovery', name: '[OCULTO] Recogida' },
          { id: 'Viewing', name: '[OCULTO] Visionado' },
          { id: 'Missing', name: '[OCULTO] Perdido' },
          { id: 'BackupDevice', name: '[OCULTO] Reserva' },
          { id: 'onlyStatusWarning', name: '[Estado] Warning', color: 'orange' },
          { id: 'onlyStatusError', name: '[Estado] Error', color: 'red' },
          { id: 'onlyStatusNoSubscriptions', name: '[Estado] No subscriptions', color: 'gray' },
        ].map(item => {
            item.name = item.name.toUpperCase()
            return item
          })
      },
      sortItems () {
        return ['Network', 'Serial', 'Name', 'Description', 'Model', 'Family', 'Status', 'Firmware', 'LastModifiedDate', 'LastHeartbeatTime', 'LastContentCheckTime', 'LastErrorTime', 'TimeStartDownload','TimeEndDownload', 'PresentationName', 'TargetGroupName', 'TargetTimeZone', 'ReportedGroupName', 'ReportedTimeZone', 'WiredDHCP','WiredIP', 'WiredSubnetMask', 'WiredGateway','WiredDNS1', 'WiredDNS2','WiredDNS3', 'WirelessEnabled', 'WirelessSSID', 'WirelessDHCP', 'WirelessIP', 'WirelessSubnetMask', 'WirelessGateway', 'WirelessDNS1', 'WirelessDNS2', 'WirelessDNS3', 'Uptime', 'HealthReportingPeriod', 'HealthStatus', 'Snapshot']
      },
      pageCount () {
        let page = this.count > 0 ? parseInt(this.count / this.itemsPerPage, 10) : 0
        if (this.count > 0 && (this.count % this.itemsPerPage)!== 0) page++
        return page
      },
    },
    watch: {
      errorByMonth () {
        this.getStats(true)
      },
      selectedNetwork (v) {
        this.page = 1
        if (!v) localStorage.removeItem('network')
        else localStorage.setItem('network', v)
        this.handleGetData()
      },
      selectedQueryFilter () {
        this.page = 1
        this.handleGetData()
      },
      itemsPerPage () {
        this.page = 1
        this.handleGetData()
      },
      selectedSortField () {
        this.page = 1
        this.handleGetData()
      },
      selectedSortDirection () {
        this.page = 1
        this.handleGetData()
      },
    },
    mounted () {
      this.init()
    },
    methods: {
      async init () {
        try {
          if (this.paramToken) {
            localStorage.setItem('jwt', this.paramToken)
          }
          this.user = await new Promise((resolve, reject) => axios.get(`${this.apiURL}/v1/private/brightsign/user?token=${this.token}`)
            .then (response => {
              resolve(response.data)
            })
            .catch (error => {
              reject(error)
            }))
          this.handleGetNetworks()
          if (localStorage.getItem('network') !== null) this.selectedNetwork = localStorage.getItem('network')
          await this.handleGetFocus()
          window.setInterval(() => {
            this.handleGetFocus()
          //}, 60000)
          }, 300000)
          window.setInterval(() => {
            this.handleGetData()
          }, 300000 * 3)
        } catch (error) {
          console.log(error)
        }
      },
      getColor (value) {
        return utils.getColor(value)
      },
    
      prepareNetworks (v) {
        const result = this.user.IsShowAllNetworks ? [{id: null, name: 'TODOS'}] : []
        for (const item of v) {
          result.push({id: item, name: item})
        }
        return result
      },
      handleSelectErrorDeviceID (v) {
        this.selectedErrorNetwork = v.Network
        this.selectedErrorDeviceID = v.ID
      },
      async handleGetFocus () {
        try {
          this.focus = await new Promise((resolve, reject) => axios.get(`${this.apiURL}/v1/private/brightsign/focus/?token=${this.token}`)
            .then (response => {
              resolve(response.data.map(item => this.convertItem(item)))
            })
            .catch (error => {
              reject(error)
            }))
        } catch (error) {
          console.log(error)
        }
      },
      async handleGetNetworks () {
        try {
          this.networks = await new Promise((resolve, reject) => axios.get(`${this.apiURL}/v1/private/brightsign/networks?token=${this.token}`)
            .then (response => {
              resolve(response.data)
            })
            .catch (error => {
              reject(error)
            }))
          this.handleGetData()
        } catch (error) {
          console.log(error)
        }
      },
      convertItem (item) {
        item.Uptime = item.UptimeError && item.Status === 'Normal' ? item.Uptime : null

        item.LastHeartbeatTime = this.convertTime(item.LastHeartbeatTime)
        item.LastModifiedDate = this.convertTime(item.LastModifiedDate)
        return item
      },
      handleGetRefreshSelectedDetails () {
        if (!this.selectedDetailsDevice) return
        axios.put(`${this.apiURL}/v1/private/brightsign/${this.selectedDetailsDevice.Network}/devices/${this.selectedDetailsDevice.ID}?token=${this.token}`)
          .then (response => {
            if (!response || !response.data) return
            this.selectedDetailsDevice = JSON.parse(JSON.stringify(this.convertItem(response.data)))
          })
          .catch (error => {
            console.log(error)
          })
      },
      handleForceSyncDevice (v) {
        if (!v.Focus && (!this.selectedDetailsDevice || this.selectedDetailsDevice.ID !== v.ID)) return
        axios.put(`${this.apiURL}/v1/private/brightsign/${v.Network}/devices/${v.ID}/sync?token=${this.token}`, v)
          .then (response => {
            this.handleGetRefreshSelectedDetails()
            this.handleGetFocus()
          })
          .catch (error => {
            console.log(error)
          })
      },
      handleSearch (v) {
        this.page = 1
        this.searchValue = v && v.length > 0 ? v : null
        this.handleGetData()
      },
      handleRefresh () {
        this.page = 1
        this.handleGetData()
      },
      handleGetTotals () {
        axios.put(`${this.apiURL}/v1/private/brightsign/${this.selectedNetwork ? this.selectedNetwork : ''}/totals?token=${this.token}`, this.queryFilters.filter(x => x.id))
          .then (response => {
            this.totals = response.data
          })
          .catch (error => {
            console.log(error)
          })
      },
      async handleGetData () {
        try {
          this.handleGetTotals()
          const body = {
            onlyError: this.selectedQueryFilter === 'onlyError' ? true : false,
            onlyErrorUptime: this.selectedQueryFilter === 'onlyErrorUptime' ? true : false,
            onlySnapshots: this.selectedQueryFilter === 'onlySnapshots' ? true : false,
            onlyInstallation: this.selectedQueryFilter === 'Installation' ? true : false,
            onlyClosed: this.selectedQueryFilter === 'Closed' ? true : false,
            onlyRecovery: this.selectedQueryFilter === 'Recovery' ? true : false,
            onlyViewing: this.selectedQueryFilter === 'Viewing' ? true : false,
            onlyMissing: this.selectedQueryFilter === 'Missing' ? true : false,
            onlyBackupDevice: this.selectedQueryFilter === 'BackupDevice' ? true : false,
            onlyStatusWarning: this.selectedQueryFilter === 'onlyStatusWarning' ? true : false,
            onlyStatusError: this.selectedQueryFilter === 'onlyStatusError' ? true : false,
            onlyStatusNoSubscriptions: this.selectedQueryFilter === 'onlyStatusNoSubscriptions' ? true : false,
            startIndex: this.itemsPerPage * (this.page -1),
            itemsPerPage: this.itemsPerPage,
          }
          const result = []

          if (this.searchValue) {
            body.search = this.searchValue
          }
          if (this.selectedSortField) {
            body.orderBy = ` ${this.selectedSortField} ${this.selectedSortDirection}`
          } else {
            if (this.selectedQueryFilter) body.orderBy = ` LastHeartbeatTime ASC`
          }

          //for (const network of this.networks.filter(x => !this.selectedNetwork || x === this.selectedNetwork)) {
            this.networkLoading = ''
            result.push(...await new Promise((resolve, reject) => axios.put(`${this.apiURL}/v1/private/brightsign/${this.selectedNetwork ? this.selectedNetwork : ''}/devices/?token=${this.token}`, body)
              .then (response => {
                this.count = response.data.count
                resolve(response.data.data.map(item => {
                  return this.convertItem(item)
                }))
              })
              .catch (error => {
                reject(error)
              })))
          //}
          this.devices = result.map(item => {
            item.icons = []
            item.focus = null
            return item
          })
          //console.log(Object.keys(this.devices.shift()))
          this.networkLoading = null
        } catch (error) {
          this.networkLoading = null
          console.log(error)
        }
      },
      convertTime(v) {
        const dt = new Date(v)
        const result = `${
                dt.getFullYear().toString().padStart(4, '0')}/${
                (dt.getMonth()+1).toString().padStart(2, '0')}/${
                dt.getDate().toString().padStart(2, '0')} ${
                dt.getHours().toString().padStart(2, '0')}:${
                dt.getMinutes().toString().padStart(2, '0')}:${
                dt.getSeconds().toString().padStart(2, '0')}`

        //return result === '01/01/0001 00:00:00' ? '' : result
        const c = ['01/01/0001 00:00:00', '01/01/2001 00:00:00', '2001/01/01 00:00:00']
        return c.indexOf(result) >= 0 ? '' : result
      },
      handleUpdatePlayer (v, type) {
        this.selectedDetailsDevice = null
        v.HideType = type
        axios.patch(`${this.apiURL}/v1/private/brightsign/${v.Network}/devices/${v.ID}/hide?token=${this.token}`, v)
          .then (response => {
            this.handleGetFocus()
            this.handleGetData()
          })
          .catch (error => {
            console.log(error)
          })
      },
      handleFocus (v) {
        this.loading = true
        axios.put(`${this.apiURL}/v1/private/brightsign/${v.Network}/devices/${v.ID}/focus?token=${this.token}`, { Focus: v.Focus ? false : true })
          .then (response => {
            this.handleGetFocus()
            this.loading = false
          })
          .catch (error => {
            console.log(error)
            this.loading = false
          })
      },
      handleCloseNotes (refresh) {
        this.selectedNotesDevice = null
        if (refresh) {
          this.handleGetFocus()
          this.handleGetData()
        }
      },
      handleCloseIncremental (refresh) {
        this.selectedIncrementalDevice = null
        if (refresh) {
          this.handleGetFocus()
          this.handleGetData()
        }
      },
      handleSelectCard (v) {
        this.selectedQueryFilter = v.id
        this.handleGetData()
      },
    },
  }
</script>

<style scoped>
  .main {
    position: absolute;
    background-color: rgba(237, 237, 237);
    width: 1920px;
    min-height: calc(100vh);
  }
  .col-left {
    position: relative;
    width: 610px;
  }
  .col-right {
    position: relative;
    width: 1310px;
  }
  .card-header {
    background-color: #90A4AE;
    color: white;
    font-size: 25px;
    padding: 10px 0;
  }
</style>
